var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98 2.32a1 1 0 0 1 .117 1.993l-.117.007H7.65a3.66 3.66 0 0 0-3.655 3.475l-.005.195v8.34a3.669 3.669 0 0 0 3.475 3.665L7.66 20H10a1 1 0 0 1 .117 1.993L10 22H7.66a5.669 5.669 0 0 1-5.666-5.452l-.004-.218V7.99a5.66 5.66 0 0 1 5.443-5.666l.217-.004h2.33zm6.633 3.89.094.083 5 5c.029.028.055.059.08.09l-.08-.09a1.008 1.008 0 0 1 .293.689v.038c0 .023-.002.046-.004.07L22 12a1.008 1.008 0 0 1-.22.625l-.073.082-5 5a1 1 0 0 1-1.497-1.32l.083-.094L18.585 13H10a1 1 0 0 1-.117-1.993L10 11h8.585l-3.292-3.293a1 1 0 0 1 1.32-1.497z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLogout);
export default __webpack_public_path__ + "static/media/icons-logout.9d728e728750045e069989247baadda7.svg";
export { ForwardRef as ReactComponent };